import PropTypes from 'prop-types'
import React from 'react'
import * as Yup from 'yup'

import {
  Form,
  FormikDialog,
  FormikTextField,
  FIELD_REQUIRED,
} from 'src/modules/ui'

import { useAdmin } from '../hooks'

const EnvironmentForm = ({ handleSubmit, isSubmitting }) => {
  return (
    <Form>
      <Form.InputGroup title="Environment name">
        <FormikTextField
          fullWidth
          label="Name"
          margin="normal"
          name="name"
          type="text"
        />
      </Form.InputGroup>
      <Form.InputGroup title="Delivery Address">
        <FormikTextField
          fullWidth
          label="Address name"
          margin="normal"
          name="address.name"
          type="text"
        />
        <FormikTextField
          fullWidth
          label="Address line 1"
          margin="normal"
          name="address.line1"
          type="text"
        />
        <FormikTextField
          fullWidth
          label="Address line 2"
          margin="normal"
          name="address.line2"
          type="text"
        />
        <FormikTextField
          fullWidth
          label="City"
          margin="normal"
          name="address.city"
          type="text"
        />
        <FormikTextField
          fullWidth
          label="County"
          margin="normal"
          name="address.county"
          type="text"
        />
        <FormikTextField
          fullWidth
          label="Postcode"
          margin="normal"
          name="address.postcode"
          type="text"
        />
      </Form.InputGroup>
    </Form>
  )
}

const validationSchema = Yup.object().shape({
  name: Yup.string().required(FIELD_REQUIRED),
  address: Yup.object().shape({
    name: Yup.string().required(FIELD_REQUIRED),
    line1: Yup.string().required(FIELD_REQUIRED),
    line2: Yup.string().notRequired().nullable(),
    city: Yup.string().required(FIELD_REQUIRED),
    county: Yup.string().required(FIELD_REQUIRED),
    postcode: Yup.string().required(FIELD_REQUIRED),
  }),
})

export const AddEnvironmentsModal = ({ ...props }) => {
  const { addPurchasingEnvironments } = useAdmin()

  const initialValues = {
    name: '',
    address: {
      line1: '',
      line2: null,
      city: '',
      county: '',
      postcode: '',
    },
  }

  return (
    <FormikDialog
      initialValues={initialValues}
      onSubmit={addPurchasingEnvironments}
      submitText="Add"
      successNotification={{
        image: 'peas',
        message:
          "Congratulations! You've created a new purchasing environment.\n\nLike peas in a pod, there are many more you can create just like it.",
      }}
      title="Add purchasing environment"
      validationSchema={validationSchema}
      {...props}
    >
      <EnvironmentForm />
    </FormikDialog>
  )
}

AddEnvironmentsModal.propTypes = {
  trigger: PropTypes.func,
}

export const EditEnvironmentsModal = ({ environment, ...props }) => {
  const { updatePurchasingEnvironments } = useAdmin()

  return (
    <FormikDialog
      initialValues={environment}
      onSubmit={updatePurchasingEnvironments}
      submitText="Update"
      successNotification={{
        image: 'peas',
        message: 'Purchasing environment updated!',
      }}
      title="Edit purchasing environment"
      validationSchema={validationSchema}
      {...props}
    >
      <EnvironmentForm />
    </FormikDialog>
  )
}

EditEnvironmentsModal.propTypes = {
  trigger: PropTypes.func,
}
